import { config } from "../config"

import { ACCESS_TOKEN } from "../redux/constants"

export const streamChatCompletion = async ({ messages, signal, onChunk, onDone, onError }) => {
   const token = localStorage.getItem(ACCESS_TOKEN)

   if (!token) {
      onError?.(new Error("You must be logged in to use the chat assistant"))
      return
   }

   try {
      const response = await fetch(`${config.REACT_APP_BASEURL}/ai/chat`, {
         method: "POST",
         headers: {
            "Content-Type": "application/json",
            Authorization: token,
         },
         body: JSON.stringify({ messages }),
         signal,
      })

      if (!response.ok) {
         const errorData = await response.json().catch(() => ({}))
         const message =
            response.status === 401
               ? "Session expired. Please log in again."
               : response.status === 429
                 ? "Rate limit exceeded. Please wait a moment and try again."
                 : errorData?.error?.message || errorData?.message || `Server error (${response.status})`
         throw new Error(message)
      }

      const reader = response.body.getReader()
      const decoder = new TextDecoder()
      let accumulated = ""
      let buffer = ""

      while (true) {
         const { done, value } = await reader.read()

         if (done) {
            onDone?.(accumulated)
            break
         }

         buffer += decoder.decode(value, { stream: true })
         const lines = buffer.split("\n")
         buffer = lines.pop() || ""

         for (const line of lines) {
            const trimmed = line.trim()
            if (!trimmed || !trimmed.startsWith("data: ")) continue

            const data = trimmed.slice(6)
            if (data === "[DONE]") {
               onDone?.(accumulated)
               return
            }

            try {
               const parsed = JSON.parse(data)
               const delta = parsed.choices?.[0]?.delta?.content || ""
               if (delta) {
                  accumulated += delta
                  onChunk?.(delta, accumulated)
               }
            } catch {
               // Skip malformed JSON chunks
            }
         }
      }
   } catch (error) {
      if (error.name === "AbortError") return
      onError?.(error)
   }
}
